import { render } from "./Competition.vue?vue&type=template&id=601f64fa&ts=true"
import script from "./Competition.vue?vue&type=script&lang=ts"
export * from "./Competition.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__